import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
// import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-expenses-report',
  templateUrl: './expenses-report.component.html',
  styleUrls: ['./expenses-report.component.css']
})
export class ExpensesReportComponent implements OnInit {

  public menu_item_id = '62';
  private dp = [];
  total = '0';

  displayedColumns = ['invoice_id', 'invoice_no', 'invoice_date', 'supplier_name', 'invoice_type',
    'total', 'pay_status', 'payment_method', 'payment_date', 'paid_date', 'cc_name', 'purch_acct', 'view'];

  displayedColumns2 = ['invoice_id', 'invoice_no', 'invoice_date', 'supplier_name', 'invoice_type',
    'total', 'pay_status', 'payment_method', 'payment_date', 'paid_date', 'cc_name', 'purch_acct'];
  dataSource = new MatTableDataSource(this.dp);

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'from_date': new Date(), 'to_date': new Date(), 'invoice_type': 'all', 'payment_type_id': '0', 'supplier_no': '',
    'user_name': 'all', 'branch_id': '0', 'cc_id': 'all', 'due_payment': '', 'title': 'تقرير المصروفات'
  };

  search_obj = {
    'placeholder': 'اسم المورد/ رقم المورد/ رقم الجوال', 'class_name': 'midField',
    'table_list': [{
      'table_name': '`supplier`', 'selected_no': 'acct_number',
      'field_list': ['acct_number', 'supplier_name', 'supplier_name_en', 'mobile'],
      'condition': ''
    }]
  };

  invoice_type = [{ 'value': 'all', 'type_name': 'الكل', 'type_name_en': 'All' },
  { 'value': 'supplier_invoice', 'type_name': 'فواتير المشتريات', 'type_name_en': 'Supplier Invoices' },
  { 'value': 'return_supplier_invoice', 'type_name': 'مرتجع المشتريات', 'type_name_en': 'Return Supplier Invoices' }];

  payment_type = [];
  supplierList = [];
  users = [];
  branches = [];
  cost_center = [];
  branchList = [];
  //accounts = [];

  Expenses_Report; Supplier_Placeholder; Supplier_Invoices; Return_Supplier_Invoices;
  Supplier_Invoice; Return_Supplier_Invoice; From_Date; To_Date; All; Paid;
  Unpaid; Amount_Total; Search_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Expenses_Report').subscribe((res: string) => {
      this.Expenses_Report = res;
    });
    this.model['title'] = this.Expenses_Report;

    translate.get('Supplier_Placeholder').subscribe((res: string) => {
      this.Supplier_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Supplier_Placeholder;

    translate.get('All').subscribe((res: string) => {
      this.All = res;
    });
    this.invoice_type['0']['type_name'] = this.All;

    translate.get('Supplier_Invoices').subscribe((res: string) => {
      this.Supplier_Invoices = res;
    });
    this.invoice_type['1']['type_name'] = this.Supplier_Invoices;

    translate.get('Return_Supplier_Invoices').subscribe((res: string) => {
      this.Return_Supplier_Invoices = res;
    });
    this.invoice_type['2']['type_name'] = this.Return_Supplier_Invoices;

    translate.get('Supplier_Invoice').subscribe((res: string) => {
      this.Supplier_Invoice = res;
    });

    translate.get('Return_Supplier_Invoice').subscribe((res: string) => {
      this.Return_Supplier_Invoice = res;
    });

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Paid').subscribe((res: string) => {
      this.Paid = res;
    });

    translate.get('Unpaid').subscribe((res: string) => {
      this.Unpaid = res;
    });

    translate.get('Amount_Total').subscribe((res: string) => {
      this.Amount_Total = res;
    });

    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });
  }

  ngOnInit() {
    let obj;

    let query = "SELECT * FROM `payment_type` WHERE `status`='1' AND `payment_type_key` != 'cobon'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.payment_type = data.data['list'];
        this.payment_type.unshift({ 'payment_type_id': '0', 'payment_type_name': 'الكل', 'payment_type_name_en': 'all' });
      });

    query = this.queryList.all_costCenter;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.cost_center = data.data['list'];
        this.cost_center.unshift({ 'cc_id': '0', 'cc_name': 'الرئيسي', 'cc_name_en': 'cost_center' });
        this.cost_center.unshift({ 'cc_id': 'all', 'cc_name': 'الكل', 'cc_name_en': 'all' });
      });

    let condition = '';
    if (this.applicationConstants.user_info['user_name'] != 'mas')
      condition += " AND `user`.`user_name` != 'mas'";

    query = "SELECT `user`.`user_id`, `employee`.`name`, `employee`.`name_en`, `user`.`user_name`, `employee`.`employee_no`" +
      " FROM `user`, `employee` WHERE `user`.`status` = '1' AND `employee`.`employee_no` = `user`.`employee_no`" + condition;
        
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.users = data.data['list'];
        this.users.unshift({ 'user_name': 'all', 'name': 'الكل', 'name_en': 'All' });
      });

    query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];

        if (this.branchList.length > 1) {
          let in_condition = "";
          this.search_obj.table_list[0]['condition'] = " AND `branch_id` IN (";

          this.branchList.forEach(element => {
            if (in_condition != "")
              in_condition += ",";
              in_condition += "' " + element.branch_id + "'";
          });
          this.search_obj.table_list[0]['condition'] += in_condition + ")";
        }
        else 
          this.search_obj.table_list[0]['condition'] = " AND `branch_id` = '" + this.branchList[0]['branch_id'] + "'";

        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });
  }

  onChangeSearch = function (search_result: object) {
    this.model['supplier_no'] = search_result['no'];
  }

  search() {
    this.dp = [];
    this.total = '0';

    if (this.model['from_date'] == undefined && this.model['to_date'] == undefined && 
      this.model['invoice_type'] == 'all' && this.model['payment_type_id'] == '0' && 
      this.model['user_name'] == 'all' && this.model['cc_id'] == 'all' && this.model['branch_id'] == '0' &&
      this.model['supplier_no'] == '' && this.model['due_payment'] == '') {
      alert(this.Search_Msg);
      return;
    }

    let obj = { cmd: 'getExpensesReport' };

    if (this.model['from_date'] != undefined) 
      obj['from_date'] = this.model['from_date'].getFullYear() + "-" + 
        (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate() + ' 00:00:00';

    if (this.model['to_date'] != undefined) 
      obj['to_date'] = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + 
        "-" + this.model['to_date'].getDate() + ' 23:59:59';

    if (this.model['invoice_type'] != 'all')
      obj['invoice_type'] = this.model['invoice_type'];

    if (this.model['payment_type_id'] != '0')
      obj['payment_type_id'] = this.model['payment_type_id'];

    if (this.model['user_name'] != 'all')
      obj['user_name'] = this.model['user_name'];

    if (this.model['cc_id'] != 'all')
      obj['cc_id'] = this.model['cc_id'];

    if (this.model['branch_id'] != '0') 
      obj['branch_list'] = [{ 'branch_id':this.model['branch_id'] }];
    else 
      obj['branch_list'] = this.branchList;

    if (this.model['supplier_no'] != '')
      obj['supplier_no'] = this.model['supplier_no'];

    if (this.model['due_payment'] != '')
      obj['due_payment'] = this.model['due_payment'];

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        console.log(data);
        if (data.status['type'] == 'success') {
          this.dp = data.status['msg'][0]['list'];
          this.total = data.status['msg'][0]['total'];
        }
        else
          alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);

        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

    // if (this.model['invoice_type'] == 'all' || this.model['invoice_type'] == 'supplier_invoice' || this.model['invoice_type'] == '') {
    //   if (this.model['from_date'] != undefined) {
    //     let from_date = (this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1)
    //       + "-" + this.model['from_date'].getDate() + ' 00:00:00');
    //     condition += " AND `supplier_invoice`.`invoice_date` >= '" + from_date + "'";
    //   }
    //   if (this.model['to_date'] != undefined) {
    //     let to_date = (this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1)
    //       + "-" + this.model['to_date'].getDate() + ' 23:59:59');
    //     condition += " AND `supplier_invoice`.`invoice_date` <= '" + to_date + "'";
    //   }

    //   if (this.model['user_name'] != 'all')
    //     condition = " AND `supplier_invoice`.`created_by` = '" + this.model['user_name'] + "'";

    //   if (this.model['cc_id'] != 'all')
    //     condition += " AND `supplier_invoice`.`cost_center` = '" + this.model['cc_id'] + "'";

    //   if (this.model['supplier_no'] != '')
    //     condition += " AND `supplier_invoice`.`supplier_no` = '" + this.model['supplier_no'] + "'";

    //   if (this.model['payment_type_id'] != '0') {
    //     condition += " AND EXISTS (SELECT `invoice_no` FROM `supp_inv_payment_method` WHERE `payment_type_id`  = '"
    //       + this.model['payment_type_id'] + "' AND `supp_inv_payment_method`.`status` = '1' AND `supp_inv_payment_method`.`invoice_no` = `supplier_invoice`.`invoice_no`)";
    //   }

    //   if (this.model['due_payment'] != '') {
    //     let today = ((new Date()).getFullYear() + "-" + ((new Date()).getMonth() + 1) + "-" + (new Date()).getDate());
    //     condition += " AND `supplier_invoice`.`payment_date` <= '" + today + "'";
    //   }

    //   if (this.model['branch_id'] != '0')
    //     condition += " AND `supplier_invoice`.`branch_id` = '" + this.model['branch_id'] + "'";

    //   else if (this.model['branch_id'] == '0') {
    //     let index = 1;
    //     let list_length = this.branchList.length;

    //     condition += " AND `supplier_invoice`.`branch_id` IN (";
    //     this.branchList.forEach(element => {
    //       if (element.branch_id != '0') {
    //         if (index < list_length)
    //           condition += " '" + element.branch_id + "',";
    //         else if (index == list_length)
    //           condition += " '" + element.branch_id + "'";
    //       }
    //       index++;
    //     });
    //     condition += ")";
    //   }

    //   query = "SELECT `supplier_invoice`.*, (`supplier_invoice`.`amount` + `supplier_invoice`.`tax` - `supplier_invoice`.`discount`)" +
    //     " as 'total', `supplier`.`supplier_name`, '" + this.Supplier_Invoice +
    //     "' AS 'invoice_type', 'supplier_invoice' AS 'type' FROM `supplier_invoice`, `supplier` WHERE " +
    //     "`supplier_invoice`.`supplier_no` = `supplier`.`acct_number` AND `supplier_invoice`.`status` != '0'" +
    //     condition;

    //   // console.log(query);

    //   obj = { cmd: 'getList', query: query };

    //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //     .subscribe(data => {
    //       this.applicationConstants.appComp.hideBusyCursor();
    //       console.log(data);
    //       this.dp = data.data['list'];

    //       this.dp.forEach(element => {
    //         element.invoice_date = (element.invoice_date).substring(0, 10);
    //         element.num_total = element.total;
    //         element.total = this.utils.numberFormat(Number(element.total));

    //         // is_paid
    //         if (element.is_paid == '0')
    //           element.pay_status = this.Unpaid;
    //         else if (element.is_paid == '1')
    //           element.pay_status = this.Paid;

    //         // cost center
    //         if (element.cost_center == '0') {
    //           element.cc_name = 'الرئيسي';
    //           element.cc_name_en = 'Main';
    //         }
    //         else {
    //           let query = "SELECT * FROM `cost_center` WHERE `cc_id` = '" + element.cost_center + "' AND `status` = '1'";
    //           let obj = { cmd: 'getList', query: query };
    //           this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //             .subscribe(data => {
    //               this.applicationConstants.appComp.hideBusyCursor();

    //               let cc = data.data['list'];
    //               if (cc.length > 0)
    //                 element.cc_name = cc['0']['cc_name'];
    //             });
    //         }

    //         //payment method
    //         element.payment_method = '';
    //         query = "SELECT `payment_type`.`payment_type_name`, `payment_type`.`payment_type_key` FROM `supp_inv_payment_method`, `payment_type` WHERE `supp_inv_payment_method`.`invoice_no` = '" +
    //           element.invoice_no + "' AND `supp_inv_payment_method`.`payment_type_id` = `payment_type`.`payment_type_id` AND `supp_inv_payment_method`.`status` = '1'";
    //         obj = { cmd: 'getList', query: query };

    //         this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //           .subscribe(data => {
    //             this.applicationConstants.appComp.hideBusyCursor();
    //             let result = data.data['list'];
    //             result.forEach(element2 => {
    //               if (element.payment_method != '')
    //                 element.payment_method += ' - ';
    //               element.payment_method += element2.payment_type_name

    //               //paid date
    //               if (element.is_paid == '1' && (element2.payment_type_key == 'cash' || element2.payment_type_key == 'visa' || element2.payment_type_key == 'bank')) {
    //                 element.paid_date = element.invoice_date;
    //               }
    //               else if (element.is_paid == '1' && element.payment_voucher_no != '' && element2.payment_type_key == 'credit') {
    //                 query = "SELECT * FROM `payment_voucher` WHERE `payment_voucher_no` = '" + element.payment_voucher_no + "' AND `status`  = '1'";
    //                 obj = { cmd: 'getList', query: query };

    //                 this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //                   .subscribe(data => {
    //                     this.applicationConstants.appComp.hideBusyCursor();

    //                     let result2 = data.data['list'];
    //                     if (result2.length > 0)
    //                       element.paid_date = (result2['0']['voucher_date']).substring(0, 10);
    //                   });
    //               }
    //             });
    //           });

    //         //total
    //         this.total = (Number(this.total) + Number(element.num_total)).toFixed(2);
            
    //       });

    //       this.dataSource = new MatTableDataSource(this.dp);
    //       this.dataSource.sort = this.sort;

    //       ///////////////////// return_supplier_invoice //////////////////////

    //       if (this.model['invoice_type'] == 'all' || this.model['invoice_type'] == '' || this.model['invoice_type'] == 'return_supplier_invoice') {


    //         condition = "";

    //         if (this.model['from_date'] != undefined) {
    //           let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) +
    //             "-" + this.model['from_date'].getDate() + ' 00:00:00';
    //           condition += " AND `return_supplier_invoice`.`return_date` >= '" + from_date + "'";
    //         }
    //         if (this.model['to_date'] != undefined) {
    //           let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) +
    //             "-" + this.model['to_date'].getDate() + ' 23:59:59';
    //           condition += " AND `return_supplier_invoice`.`return_date` <= '" + to_date + "'";
    //         }

    //         if (this.model['user_name'] != 'all')
    //           condition = " AND `return_supplier_invoice`.`created_by` = '" + this.model['user_name'] + "'";

    //         if (this.model['supplier_no'] != '')
    //           condition += " AND `return_supplier_invoice`.`supplier_no` = '" + this.model['supplier_no'] + "'";

    //         if (this.model['payment_type_id'] != '0') {
    //           condition += " AND EXISTS (SELECT `return_supplier_invoice_no` FROM `ret_supp_inv_payment_method` WHERE `payment_type_id`  = '"
    //             + this.model['payment_type_id'] + "' AND `ret_supp_inv_payment_method`.`status` = '1' AND `ret_supp_inv_payment_method`.`return_supplier_invoice_no` = `return_supplier_invoice`.`return_supplier_invoice_no`)";
    //         }

    //         if (this.model['branch_id'] != '0')
    //           condition += " AND `return_supplier_invoice`.`branch_id` = '" + this.model['branch_id'] + "'";

    //         else if (this.model['branch_id'] == '0') {
    //           let index = 1;
    //           let list_length = this.branchList.length;

    //           condition += " AND `return_supplier_invoice`.`branch_id` IN (";
    //           this.branchList.forEach(element => {
    //             if (element.branch_id != '0') {
    //               if (index < list_length)
    //                 condition += " '" + element.branch_id + "',";
    //               else if (index == list_length)
    //                 condition += " '" + element.branch_id + "'";
    //             }
    //             index++;
    //           });
    //           condition += ")";
    //         }

    //         query = "SELECT `return_supplier_invoice`.*, `return_supplier_invoice`.`return_date` AS 'invoice_date', " +
    //           "`return_supplier_invoice_no` AS 'invoice_no', `ret_purch_acct` AS 'purch_acct', " +
    //           "(`return_supplier_invoice`.`total` + `return_supplier_invoice`.`tax` - `return_supplier_invoice`.`discount`)" +
    //           " AS 'total', `supplier`.`acct_number`, `supplier`.`supplier_name`, '" +
    //           this.Return_Supplier_Invoice + "' AS 'invoice_type', 'return_supplier_invoice' AS 'type' FROM `return_supplier_invoice`," +
    //           " `supplier` WHERE `supplier`.`acct_number` = `return_supplier_invoice`.`supplier_no` AND " +
    //           "`return_supplier_invoice`.`status` != '0'" + condition;

    //         // console.log(query);

    //         obj = { cmd: 'getList', query: query };

    //         this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //           .subscribe(data => {
    //             this.applicationConstants.appComp.hideBusyCursor();

    //             if (data.data['list'].length > 0) {
    //               data.data['list'].forEach(element => {
    //                 element.invoice_date = (element.invoice_date).substring(0, 10);
    //                 element.num_total = element.total;
    //                 element.total = this.utils.numberFormat(Number(element.total));

    //                 //is paid
    //                 if (element.is_paid == '0')
    //                   element.pay_status = this.Unpaid;
    //                 else if (element.is_paid == '1')
    //                   element.pay_status = this.Paid;

    //                 //payment method
    //                 element.payment_method = '';
    //                 query = "SELECT `payment_type`.`payment_type_name`, `payment_type`.`payment_type_key` FROM `ret_supp_inv_payment_method`, `payment_type` WHERE `ret_supp_inv_payment_method`.`return_supplier_invoice_no` = '" +
    //                   element.invoice_no + "' AND `ret_supp_inv_payment_method`.`payment_type_id` = `payment_type`.`payment_type_id` AND `ret_supp_inv_payment_method`.`status` = '1'";
    //                 obj = { cmd: 'getList', query: query };

    //                 this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //                   .subscribe(data => {
    //                     this.applicationConstants.appComp.hideBusyCursor();
    //                     let result = data.data['list'];
    //                     result.forEach(element2 => {
    //                       if (element.payment_method != '')
    //                         element.payment_method += ' - ';
    //                       element.payment_method += element2.payment_type_name

    //                       //paid date
    //                       if (element.is_paid == '1' && (element2.payment_type_key == 'cash' || element2.payment_type_key == 'visa' || element2.payment_type_key == 'bank')) {
    //                         element.paid_date = element.invoice_date;
    //                       }
    //                       else if (element.is_paid == '1' && element.cash_receipt_no != '' && element2.payment_type_key == 'credit') {
    //                         query = "SELECT * FROM `cash_receipt` WHERE `cash_receipt_no` = '" + element.cash_receipt_no + "' AND `status`  = '1'";
    //                         obj = { cmd: 'getList', query: query };

    //                         this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //                           .subscribe(data => {
    //                             this.applicationConstants.appComp.hideBusyCursor();

    //                             let result2 = data.data['list'];
    //                             if (result2.length > 0)
    //                               element.paid_date = (result2['0']['voucher_date']).substring(0, 10);
    //                           });
    //                       }
    //                     });
    //                   });

    //                 this.dp.push(element);

    //                 //total
    //                 this.total = (Number(this.total) - Number(element.num_total)).toFixed(2);
    //               });
    //               // this.dp = data.data['list'];
    //             }
    //             this.dataSource = new MatTableDataSource(this.dp);
    //             this.dataSource.sort = this.sort;

    //           });

    //       }
    //     });
    // }

    // ///////////////////// only return_supplier_invoice //////////////////////

    // else if (this.model['invoice_type'] == 'return_supplier_invoice') {


    //   condition = "";

    //   if (this.model['from_date'] != undefined) {
    //     let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) +
    //       "-" + this.model['from_date'].getDate() + ' 00:00:00';
    //     condition += " AND `return_supplier_invoice`.`return_date` >= '" + from_date + "'";
    //   }
    //   if (this.model['to_date'] != undefined) {
    //     let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) +
    //       "-" + this.model['to_date'].getDate() + ' 23:59:59';
    //     condition += " AND `return_supplier_invoice`.`return_date` <= '" + to_date + "'";
    //   }

    //   if (this.model['user_name'] != 'all')
    //     condition = " AND `return_supplier_invoice`.`created_by` = '" + this.model['user_name'] + "'";

    //   if (this.model['supplier_no'] != '')
    //     condition += " AND `return_supplier_invoice`.`supplier_no` = '" + this.model['supplier_no'] + "'";

    //   if (this.model['payment_type_id'] != '0') {
    //     condition += " AND EXISTS (SELECT `return_supplier_invoice_no` FROM `ret_supp_inv_payment_method` WHERE `payment_type_id`  = '"
    //       + this.model['payment_type_id'] + "' AND `ret_supp_inv_payment_method`.`status` = '1' AND `ret_supp_inv_payment_method`.`return_supplier_invoice_no` = `return_supplier_invoice`.`return_supplier_invoice_no`)";
    //   }

    //   if (this.model['branch_id'] != '0')
    //     condition += " AND `return_supplier_invoice`.`branch_id` = '" + this.model['branch_id'] + "'";

    //   else if (this.model['branch_id'] == '0') {
    //     let index = 1;
    //     let list_length = this.branchList.length;

    //     condition += " AND `return_supplier_invoice`.`branch_id` IN (";
    //     this.branchList.forEach(element => {
    //       if (element.branch_id != '0') {
    //         if (index < list_length)
    //           condition += " '" + element.branch_id + "',";
    //         else if (index == list_length)
    //           condition += " '" + element.branch_id + "'";
    //       }
    //       index++;
    //     });
    //     condition += ")";
    //   }

    //   query = "SELECT `return_supplier_invoice`.*, `return_supplier_invoice`.`return_date` AS 'invoice_date', " +
    //     "`return_supplier_invoice_no` AS 'invoice_no', `ret_purch_acct` AS 'purch_acct', " +
    //     "(`return_supplier_invoice`.`total` + `return_supplier_invoice`.`tax` - `return_supplier_invoice`.`discount`)" +
    //     " AS 'total', `supplier`.`acct_number`, `supplier`.`supplier_name`, '" +
    //     this.Return_Supplier_Invoice + "' AS 'invoice_type', 'return_supplier_invoice' AS 'type' FROM `return_supplier_invoice`," +
    //     " `supplier` WHERE `supplier`.`acct_number` = `return_supplier_invoice`.`supplier_no` AND " +
    //     "`return_supplier_invoice`.`status` != '0'" + condition;

    //   // console.log(query);

    //   obj = { cmd: 'getList', query: query };

    //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //     .subscribe(data => {
    //       this.applicationConstants.appComp.hideBusyCursor();
    //       if (data.data['list'].length > 0) {
    //         data.data['list'].forEach(element => {
    //           element.invoice_date = (element.invoice_date).substring(0, 10);
    //           element.num_total = element.total;
    //           element.total = this.utils.numberFormat(Number(element.total));

    //           //is paid
    //           if (element.is_paid == '0')
    //             element.pay_status = this.Unpaid;
    //           else if (element.is_paid == '1')
    //             element.pay_status = this.Paid;

    //           //payment method
    //           element.payment_method = '';
    //           query = "SELECT `payment_type`.`payment_type_name`, `payment_type`.`payment_type_key` FROM `ret_supp_inv_payment_method`, `payment_type` WHERE `ret_supp_inv_payment_method`.`return_supplier_invoice_no` = '" +
    //             element.invoice_no + "' AND `ret_supp_inv_payment_method`.`payment_type_id` = `payment_type`.`payment_type_id` AND `ret_supp_inv_payment_method`.`status` = '1'";
    //           obj = { cmd: 'getList', query: query };

    //           this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //             .subscribe(data => {
    //               this.applicationConstants.appComp.hideBusyCursor();
    //               let result = data.data['list'];
    //               result.forEach(element2 => {
    //                 if (element.payment_method != '')
    //                   element.payment_method += ' - ';
    //                 element.payment_method += element2.payment_type_name

    //                 //paid date
    //                 if (element.is_paid == '1' && (element2.payment_type_key == 'cash' || element2.payment_type_key == 'visa' || element2.payment_type_key == 'bank')) {
    //                   element.paid_date = element.invoice_date;
    //                 }
    //                 else if (element.is_paid == '1' && element.cash_receipt_no != '' && element2.payment_type_key == 'credit') {
    //                   query = "SELECT * FROM `cash_receipt` WHERE `cash_receipt_no` = '" + element.cash_receipt_no + "' AND `status`  = '1'";
    //                   obj = { cmd: 'getList', query: query };

    //                   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //                     .subscribe(data => {
    //                       this.applicationConstants.appComp.hideBusyCursor();

    //                       let result2 = data.data['list'];
    //                       if (result2.length > 0)
    //                         element.paid_date = (result2['0']['voucher_date']).substring(0, 10);
    //                     });
    //                 }
    //               });
    //             });

    //           this.dp.push(element);

    //           //total
    //           this.total = (Number(this.total) - Number(element.num_total)).toFixed(2);
    //         });
    //         // this.dp = data.data['list'];
    //       }
    //       this.dataSource = new MatTableDataSource(this.dp);
    //       this.dataSource.sort = this.sort;

    //     });

    // }
    // else {
    //   this.dataSource = new MatTableDataSource(this.dp);
    //   this.dataSource.sort = this.sort;
    // }

  }

  print() {
    let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
      this.model['from_date'].getDate();
    let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
      this.model['to_date'].getDate();
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"><h2>' + this.Expenses_Report + '</h2></td></tr>';
    html_data += '<tr><td width="33%"> ' + this.From_Date + ': ' + from_date + '</td><td width="33%"> ' + this.To_Date + ': ' + to_date + '</td></tr>';
    html_data += '<tr><td width="33%"> ' + this.Amount_Total + ': ' + this.total + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('expenses_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
